import { Entity } from '@square/ignition';
import { createContext, useContext } from 'react';

interface ApiReferenceFieldContext {
  openModal: (entity: Entity, entityStack: Array<Entity>) => void;
}

const ApiReferenceFieldContextInstance =
  createContext<ApiReferenceFieldContext>({
    openModal: () => null,
  });

const ApiReferenceFieldContextProvider =
  ApiReferenceFieldContextInstance.Provider;

const useApiRferenceFieldContext = () => {
  return useContext(ApiReferenceFieldContextInstance);
};

export {
  ApiReferenceFieldContextProvider,
  ApiReferenceFieldContextInstance,
  useApiRferenceFieldContext,
  type ApiReferenceFieldContext,
};
